import React from "react";
import { Modal } from "@mui/material";

import { SimpleConfirmModalProps } from "./models";

import { Button, OutlineButton } from "application/components";

import { Card, Container, ButtonsSection, Description } from "./styles";

const SimpleConfirmModal = ({
  title,
  visible,
  loading,
  description,
  submitButtonTitle,
  cancelButtonTitle,
  buttonsDirection = "column",
  onClose,
  onSubmit,
}: SimpleConfirmModalProps) => {
  return (
    <Modal open={visible}>
      <Container>
        <Card>
          <h4>{title}</h4>

          <Description>{description}</Description>

          <ButtonsSection buttonsDirection={buttonsDirection}>
            <Button type="submit" disabled={loading} onClick={onSubmit}>
              {submitButtonTitle}
            </Button>
            <OutlineButton disabled={loading} onClick={onClose}>
              {cancelButtonTitle}
            </OutlineButton>
          </ButtonsSection>
        </Card>
      </Container>
    </Modal>
  );
};

export default SimpleConfirmModal;
